import type { LucideIcon } from "lucide-react";
import type { RouteObject } from "react-router";
import { authModule } from "./auth/routes";
import { cartModule } from "./cart/routes";
import { catalogModule } from "./catalog/routes";
import { checkoutModule } from "./checkout/routes";
import { legalModule } from "./legal/routes";
import { notificationsModule } from "./notifications/routes";
import { ordersModule } from "./orders/routes";
import { vehiclesModule } from "./vehicles/routes";

export type NavItem = {
  id: string;
  title: string;
  url: string;
  icon: LucideIcon;
};

export type WebModule = {
  readonly id: string;
  readonly nav: NavItem | readonly NavItem[] | null;
  readonly routes: readonly RouteObject[];
  readonly publicRoutes: readonly RouteObject[];
};

export const modules: readonly WebModule[] = [
  catalogModule,
  cartModule,
  vehiclesModule,
  ordersModule,
  authModule,
  checkoutModule,
  notificationsModule,
  legalModule,
];

export const navigationMenus: NavItem[] = modules.flatMap((module) =>
  module.nav === null ? [] : Array.isArray(module.nav) ? module.nav : [module.nav],
);

export const protectedRoutes: RouteObject[] = modules.flatMap((module) => [...module.routes]);

export const publicRoutes: RouteObject[] = modules.flatMap((module) => [...module.publicRoutes]);
